import { withCardCalibrationReferences, type GameDefinition } from '@archon3d/core';
import { newId } from './newId';

/** A new game's own snapshot, including Expert stats and nested level percentages. */
export function copyEditableGame(source: GameDefinition, name: string): GameDefinition {
  const copy = withCardCalibrationReferences(source);
  copy.id = `game-${newId()}`;
  copy.name = name;
  copy.board.id = copy.id;
  copy.board.name = name;
  return copy;
}
